<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage" id="tp01">
<p class="centerImage0"><img alt="image" class="epubimage" height="6" src="OEBPS/images/li.jpg" width="436"/></p>
<h2 class="titlePageAuthor" style="text-indent: 0%;"><span class="bold">NOAM CHOMSKY</span></h2>
<h2 class="titlePageTitle" style="text-indent: 0%;"><span class="bold">POWER SYSTEMS</span></h2>
<p class="centerImage1"><img alt="image" class="epubimage" height="6" src="OEBPS/images/li.jpg" width="436"/></p>
<p class="titlePageSubtitle" style="text-indent: 0%;"><span class="bold">CONVERSATIONS ON GLOBAL DEMOCRATIC UPRISINGS AND THE NEW CHALLENGES TO U.S. EMPIRE</span></p>
<p class="titlePageText"><span class="smallCaps">INTERVIEWS WITH</span><br/> <span class="bold">D<span class="smallCaps">AVID</span> B<span class="smallCaps">ARSAMIAN</span></span></p>
<p class="titlePagePublisher" style="text-indent: 0%;">M<span class="smallCaps">ETROPOLITAN</span> B<span class="smallCaps">OOKS</span><br/><span class="smallCaps">HENRY HOLT AND COMPANY • NEW YORK</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780805096163_tp01.vue?5fb7f685